export const home = {
  labels: {
    games: "Notícias",
    company: "A Empresa",
    facebook: "facebook",
    instagram: "instagram",
    twitter: "twitter",
    terms_of_use: "Termo de uso",
    privacy: "Termo de Privacidade",
  },
  tooltips: {
    go_to: {
      facebook: "Ir para o Facebook",
      instagram: "Ir para o Instagram",
      twitter: "Ir para o Twitter",
    },
  },
  banner: {
    title: "Mais de 2 bilhões de vídeos assistidos a cada mês.",
    subtitle: "A maior audiência de jogos nas redes sociais",
  },
  games: {
    title: "",
    resume: "",
    items: {
      section1: "Criação de Vídeos com I.A",
      section2: "Mais de 100 canais ativos em 7 idiomas",
      section3: "A maior audiência de jogos nas redes sociais",
      section4: "340 milhões de visualizadores únicos mensais no mundo todo",
    },
  },
  company: {
    about: [
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
      "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy. Various versions have evolved over the years, sometimes by accident, sometimes on purpose (injected humour and the like).",
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
    ],
  },
  footer: {
    resume:
      "Prota Games usa IA para escalar o conteúdo de jogos mais envolvente do mundo nas redes sociais",
    copyright: "Prota Games, all rights reserved",
  },
};
